import rebrand from '../../config/rebrand';
import * as config from './config';

export const getScript = (box = '') => {
  const klickboxManagerScript = rebrand.urls.KLICKBOX_MANAGER_SCRIPT;

  return config.SCRIPT
    .replace('{{BOX_ID}}', box.id)
    .replace('{{MANAGER_SCRIPT}}', klickboxManagerScript);
};



/** WEBPACK FOOTER **
 ** ./src/helpers/code/index.js
 **/